export const ROLES = {
    User: "user",
    Admin: "admin"
}